import React from "react";
import LogoWhiteImage from "/logoWhite.png";

interface Props {
    /**
     * Styles to apply to the `img` element
     */
    style?: React.CSSProperties;
}

export const LogoWhite = ({ style }: Props) => {
    return (
        <a
            className="flex"
            href="https://www.insurescope.ai"
            target="_blank"
            rel="noreferrer"
            tabIndex={-1}
        >
            <img src={LogoWhiteImage} alt="ContractScope Logo" style={style} />
        </a>
    );
};
